import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {getQueueDetails} from "../../services/queue";
import {nextTurnInQueue, endCurrentCustomer, getCurrentCustomer} from "../../services/employee";
import {connectToSocket, emitSocketEvent, onSocketEvent} from "../../services/socket";
import {useAuth} from "../../context/AuthContext";
import SkeletonInstitutionCard from "../../components/Cards/InstitutionCardSkeleton/InstitutionCardSkeleton";

const QueueDetailsPage = () => {
    const {queueId} = useParams();
    const {token} = useAuth();

    const [queueData, setQueueData] = useState(null);
    const [queueLiveData, setQueueLiveData] = useState(null);
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [isFetchingCustomer, setIsFetchingCustomer] = useState(false);

    const fetchQueueDetails = async () => {
        try {
            const res = await getQueueDetails(queueId);
            setQueueData(res.data);
            setQueueLiveData({
                waitingCount: res.data.waitingCount,
                estimatedWaitingTime: res.data.estimatedWaitingTime,
                averageWaitPerCustomer: res.data.averageWaitPerCustomer
            });
        } catch (err) {
            console.error("Error fetching queue details:", err);
        }
    };

    const fetchCurrentCustomer = async () => {
        try {
            const res = await getCurrentCustomer(token);
            if (res.data?.nextTurn?.queueId === Number(queueId)) {
                setCurrentCustomer(res.data.nextTurn);
            }
        } catch (err) {
            console.error("Error fetching current customer:", err);
        }
    };

    const serveNext = async () => {
        setIsFetchingCustomer(true);
        try {
            const res = await nextTurnInQueue(token, queueId);
            setCurrentCustomer(res.data?.result ?? null);
        } catch (err) {
            console.error("Error serving next customer:", err);
        } finally {
            setIsFetchingCustomer(false);
        }
    };

    const endCurrent = async () => {
        try {
            await endCurrentCustomer(token, queueId);
            setCurrentCustomer(null);
        } catch (err) {
            console.error("Error ending current turn:", err);
        }
    };

    useEffect(() => {
        if (!queueId) return;
        connectToSocket();
        fetchQueueDetails();
        fetchCurrentCustomer();

        emitSocketEvent("join-queue-room", {queueId});
        onSocketEvent("queue:stats:update", (data) => {
            if (data.queueId === Number(queueId)) {
                setQueueLiveData({
                    waitingCount: data.waitingCount,
                    estimatedWaitingTime: data.estimatedWaitingTime,
                    averageWaitPerCustomer: data.averageWaitPerCustomer
                });
            }
        });
    }, [queueId]);

    if (!queueData || !queueLiveData) return <SkeletonInstitutionCard/>;
    return (
        <div className="page" style={{padding: 20, direction: "rtl"}}>
            <div className='content-view'>
                <h2>📋 طابور خدمة - {queueData.service.name}</h2>
                <div style={{
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: 12,
                    padding: 20,
                    marginTop: 20
                }}>
                    <p><strong>الفرع:</strong> {queueData.branch.name}</p>
                    <p><strong>الخدمة:</strong> {queueData.service.name}</p>
                    <p><strong>عدد المنتظرين:</strong> {queueLiveData.waitingCount}</p>
                    <p><strong>الانتظار المتوقع لكل عميل:</strong> {queueLiveData.estimatedWaitingTime} دقيقة</p>
                </div>

                {isFetchingCustomer ? <div style={{
                    marginTop: 30,
                    padding: 20,
                    backgroundColor: "#fefefe",
                    border: "1px solid #ccc",
                    borderRadius: 12
                }}><SkeletonInstitutionCard/></div> : (
                    currentCustomer ? (
                        <div style={{
                            marginTop: 30,
                            padding: 20,
                            backgroundColor: "#fefefe",
                            border: "1px solid #ccc",
                            borderRadius: 12
                        }}>
                            <h3>🟢 يتم خدمة العميل #{currentCustomer.customerTurn}</h3>
                            <p><strong>الاسم:</strong> {currentCustomer.customer?.name || "—"}</p>
                            <p><strong>الهاتف:</strong> {currentCustomer.customer?.phoneNumber || "—"}</p>
                            <button onClick={endCurrent} className="btn filled danger">❌ إنهاء الدور</button>
                        </div>
                    ) : (
                        <div style={{marginTop: 30}}>
                            {queueLiveData.waitingCount === 0 ? <h3>لا يوجد عملاء حالياً</h3> : (
                                <button onClick={serveNext} className="btn filled">⏭️ خدمة التالي</button>
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default QueueDetailsPage;
